<script>
    import { FontAwesomeIcon } from "@fortawesome/svelte-fontawesome";
    import { faDiscord, faTiktok, faYoutube, faXTwitter } from "@fortawesome/free-brands-svg-icons";

    const socialLinks = [
        { name: "Discord", url: "https://discord.gg/scprime", icon: faDiscord, color: "#5865F2" },
        { name: "X", url: "https://x.com/gospelofgsd", icon: faXTwitter, color: "#000000" },
        { name: "Youtube", url: "https://www.youtube.com/@reyna-coin", icon: faYoutube, color: "#FF0000"},
        { name: "Tiktok", url: "https://www.tiktok.com/@reyna.coin", icon: faTiktok, color: "#000000"},
        // { name: "Birdeye", url: "https://birdeye.so/token/4zyE51eWthh21ZNBB5rymdV3Pgen2DXH7HiLdfi2AKtX", icon: "/images/birdeye_logo.png", color: "#F39C12" },
    ];
</script>

<section>
    <ul>
        {#each socialLinks as { name, url, icon, color }}
            <li>
                <a href={url} target="_blank" rel="noopener noreferrer" aria-label={name}>
                    {#if icon && typeof icon === 'object'}
                        <FontAwesomeIcon icon={icon} style="color: {color};" />
                    {:else if icon && typeof icon === 'string'}
                        <img src={icon} alt={name} class="custom-icon" />
                    {:else}
                        <span class="custom-icon" style="color: {color};">&nbsp;𝕏</span>
                    {/if}
                </a>
            </li>
        {/each}
    </ul>
</section>

<style>
    /* Floating to top right of the viewport */
    section {
        position: fixed;
        top: 1rem;
        right: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        background: rgba(255, 255, 255, 0.8);
        padding: 0.5rem;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 1000;
    }

    ul {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        list-style: none;
        padding: 0;
        margin: 0;
        align-items: center;
    }

    li {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        text-decoration: none;
        transition: transform 0.2s;
        font-size: 1.8rem;
        color: inherit;
    }

    a:hover {
        transform: scale(1.1);
    }

    /* Uniform icon styling */
    .custom-icon,
    .custom-icon svg {
        width: 32px;
        height: 32px;
    }

    /* Specific styling for image-based icon */
    .custom-icon {
        object-fit: contain;
    }
</style>
